<template>
	<div>
		<h1>Module not found</h1>
	</div>
</template>

<script>
export default {}
</script>
